import { render } from "./LeaveMessage.vue?vue&type=template&id=1d2ba514&scoped=true"
import script from "./LeaveMessage.vue?vue&type=script&lang=js"
export * from "./LeaveMessage.vue?vue&type=script&lang=js"

import "./LeaveMessage.vue?vue&type=style&index=0&id=1d2ba514&lang=scss&scoped=true"

import exportComponent from "D:\\myGithub\\customer-web-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2ba514"]])

export default __exports__